import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '@/seo/seoData';

export default function JsonLdManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll('script[data-seo-jsonld]')
      .forEach((el) => el.remove());

    const seo = resolveSeo(pathname);

    seo.jsonLd.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [pathname]);

  return null;
}